(function() {
  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {
    // Get elements with null checks
    const slider = document.getElementById('full-screen-slider');
    if (!slider) return; // Exit if no slider exists
    
    const slides = slider.querySelectorAll('.full-screen-slide');
    const sliderNav = document.getElementById('full-screen-sliderNav');
    const prevBtn = document.getElementById('full-screen-prevBtn');
    const nextBtn = document.getElementById('full-screen-nextBtn');
    const container = document.getElementById('full-screen-sliderContainer');
    const thumbnailsContainer = document.getElementById('full-screen-thumbnails');
    const thumbnails = thumbnailsContainer ? thumbnailsContainer.querySelectorAll('.full-screen-thumbnail-wrapper') : [];

    const state = {
      currentIndex: 0,
      slideCount: slides.length,
      isAnimating: false,
      autoSlideTimer: null,
      navigationStyle: sliderNav && sliderNav.classList.contains('mobile-only') ? 'thumbnails' : 'dots'
    };

    // Check for passive event support
    const supportsPassive = (function() {
      let result = false;
      try {
        const opts = Object.defineProperty({}, 'passive', {
          get: function() {
            result = true;
            return true;
          },
        });
        window.addEventListener('test', null, opts);
        window.removeEventListener('test', null, opts);
      } catch (e) {}
      return result;
    })();

    const passiveOpts = supportsPassive ? { passive: true } : false;

    function lazyLoadImages() {
      const lazyImages = slider.querySelectorAll('.full-screen-prod-lazy-img[data-src]');
      
      if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const img = entry.target;
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
              observer.unobserve(img);
            }
          });
        }, {
          rootMargin: '100px 0px 100px 0px',
          threshold: 0.01
        });
        
        lazyImages.forEach(img => {
          imageObserver.observe(img);
        });
      } else {
        // Fallback for browsers without IntersectionObserver
        lazyImages.forEach(img => {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        });
      }
    }

    function preloadAdjacentSlides() {
      if (state.slideCount <= 1) return;
      
      const indicesToPreload = [
        state.currentIndex,
        (state.currentIndex + 1) % state.slideCount,
        (state.currentIndex - 1 + state.slideCount) % state.slideCount
      ];
      
      indicesToPreload.forEach(index => {
        const slide = slides[index];
        if (!slide) return;
        
        // Preload images
        const lazyImages = slide.querySelectorAll('img[data-src]');
        lazyImages.forEach(img => {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        });
        
        // Preload videos
        const lazyVideos = slide.querySelectorAll('video.lazy-video');
        lazyVideos.forEach(video => {
          const sources = video.querySelectorAll('source[data-src]');
          let needsReload = false;
          
          sources.forEach(source => {
            if (source.dataset.src) {
              source.src = source.dataset.src;
              source.removeAttribute('data-src');
              needsReload = true;
            }
          });
          
          if (needsReload) {
            video.load();
          }
        });
      });
    }

    function createDots() {
      if (!sliderNav) return;
      
      const fragment = document.createDocumentFragment();
      for (let i = 0; i < state.slideCount; i++) {
        const dot = document.createElement('div');
        dot.classList.add('full-screen-nav-dot');
        if (i === 0) dot.classList.add('full-screen-active');
        dot.dataset.index = i;
        fragment.appendChild(dot);
      }
      sliderNav.appendChild(fragment);
    }

    function updateSlider() {
      if (!slider) return;
      
      slider.style.transform = `translateX(-${state.currentIndex * 100}%)`;
      
      // Update dots if they exist
      if (sliderNav) {
        const dots = sliderNav.children;
        for (let i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('full-screen-active', i === state.currentIndex);
        }
      }
      
      // Update thumbnails if they exist
      if (thumbnails && thumbnails.length > 0) {
        for (let i = 0; i < thumbnails.length; i++) {
          thumbnails[i].classList.toggle('active', i === state.currentIndex);
        }
      }
    }

    function goToSlide(index) {
      if (state.isAnimating || index === state.currentIndex) return;
      
      state.isAnimating = true;
      state.currentIndex = index;
      updateSlider();

      // Load videos in the current slide and set up mute buttons
      const currentSlide = slides[index];
      if (currentSlide) {
        // Handle all videos in the slide
        const allVideos = currentSlide.querySelectorAll('video');
        allVideos.forEach(video => {
          // Load any lazy videos
          if (video.classList.contains('lazy-video')) {
            const sources = video.querySelectorAll('source[data-src]');
            let needsReload = false;
            
            sources.forEach(source => {
              if (source.dataset.src) {
                source.src = source.dataset.src;
                source.removeAttribute('data-src');
                needsReload = true;
              }
            });
            
            if (needsReload) {
              video.load();
            }
          }
          
          // Always attempt to play the video
          video.play().catch(e => {
            console.log("Autoplay prevented:", e);
          });
        });
      }

      // Preload adjacent slides
      setTimeout(() => {
        preloadAdjacentSlides();
      }, 100);

      // Initialize mute buttons for current slide
      setTimeout(() => {
        initMuteButtons();
      }, 150);

      // Dispatch event for slide change
      setTimeout(() => {
        dispatchSlideChangedEvent(index + 1);
        state.isAnimating = false;
      }, 300);
    }

    function dispatchSlideChangedEvent(index) {
      const customEvent = new CustomEvent("full-screenSlideChanged", {
        detail: { index: index }
      });
      document.dispatchEvent(customEvent);
    }

    function nextSlide() {
      if (state.isAnimating || state.slideCount <= 1) return;
      const nextIndex = (state.currentIndex + 1) % state.slideCount;
      goToSlide(nextIndex);
    }

    function prevSlide() {
      if (state.isAnimating || state.slideCount <= 1) return;
      const prevIndex = (state.currentIndex - 1 + state.slideCount) % state.slideCount;
      goToSlide(prevIndex);
    }

    function startAutoSlide() {
      if (state.slideCount <= 1) return;
      clearInterval(state.autoSlideTimer);
      state.autoSlideTimer = setInterval(nextSlide, 5000);
    }

    function pauseAutoSlide() {
      clearInterval(state.autoSlideTimer);
    }

    function handleTouchStart(e) {
      state.touchStartX = e.changedTouches[0].screenX;
    }

    function handleTouchEnd(e) {
      if (state.isAnimating) return;
      const diff = e.changedTouches[0].screenX - state.touchStartX;
      if (Math.abs(diff) < 50) return;
      diff < 0 ? nextSlide() : prevSlide();
    }

    function handleDotClick(e) {
      if (e.target.classList.contains('full-screen-nav-dot') && !state.isAnimating) {
        const index = parseInt(e.target.dataset.index, 10);
        goToSlide(index);
      }
    }

    function handleVisibility() {
      document.hidden ? pauseAutoSlide() : startAutoSlide();
    }

    function handleMouseDown(e) {
      state.mouseDown = true;
      state.startX = e.clientX;
    }

    function handleMouseUp(e) {
      if (!state.mouseDown || state.isAnimating) return;
      state.mouseDown = false;
      const diff = e.clientX - state.startX;
      if (Math.abs(diff) < 50) return;
      diff < 0 ? nextSlide() : prevSlide();
    }

    function handleMouseLeave() {
      if (!state.mouseDown) return;
      state.mouseDown = false;
    }

    function init() {
      // Always initialize lazy loading
      lazyLoadImages();
      
      // Only create dots and set up navigation if there's more than one slide
      if (state.slideCount > 1) {
        // Only create dots if sliderNav exists
        if (sliderNav) {
          createDots();
          sliderNav.addEventListener('click', handleDotClick);
        }
        
        document.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') prevSlide();
          if (e.key === 'ArrowRight') nextSlide();
        });
        
        // Add event listeners for prev/next buttons only if they exist
        if (prevBtn) prevBtn.addEventListener('click', prevSlide);
        if (nextBtn) nextBtn.addEventListener('click', nextSlide);
        
        // Add event listeners for container only if it exists
        if (container) {
          container.addEventListener('mouseenter', pauseAutoSlide);
          container.addEventListener('mouseleave', startAutoSlide);
        }
        
        document.addEventListener('visibilitychange', handleVisibility);
        startAutoSlide();

        // Setup thumbnail clicks only if thumbnails exist
        if (thumbnails && thumbnails.length > 0) {
          thumbnails.forEach(thumb => {
            thumb.addEventListener('click', (e) => {
              const index = parseInt(e.currentTarget.dataset.index, 10);
              if (!isNaN(index)) {
                goToSlide(index);
              }
            });
          });
        }
      } else {
        // Hide navigation elements if only one slide
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        
        if (thumbnailsContainer) thumbnailsContainer.style.display = 'none';
        if (sliderNav) sliderNav.style.display = 'none';
      }
      
      // These event listeners should be active regardless of slide count
      if (slider) {
        slider.addEventListener('touchstart', handleTouchStart, passiveOpts);
        slider.addEventListener('touchend', handleTouchEnd, passiveOpts);
        slider.addEventListener('mousedown', handleMouseDown);
        slider.addEventListener('mouseup', handleMouseUp);
        slider.addEventListener('mouseleave', handleMouseLeave);
      }

      // Preload videos in the first slide
      const firstSlide = slides[0];
      if (firstSlide) {
        const videos = firstSlide.querySelectorAll('video');
        videos.forEach(video => {
          if (video.muted) {
            video.play().catch(e => {
              console.log("Autoplay prevented:", e);
            });
          }
        });
      }
    }

    // Initialize the slider
    init();

    // Track which slides have been viewed
    const triggeredSlides = new Set();
    document.addEventListener('full-screenSlideChanged', function(e) {
      const index = e.detail.index;
      
      if (!triggeredSlides.has(index)) {
        // If you have a tracking function
        if (typeof gaEvent === 'function') {
          gaEvent('pdp_img', [index, "", "", "", "", ""], false);
        }
        triggeredSlides.add(index);
      }
    });

    // Handle review section scroll
    document.querySelectorAll('.full-screen-pdp-product-reviews-wrapper').forEach(wrapper => {
      wrapper.addEventListener('click', function() {
        const targetClass = this.getAttribute('data-scroll-to');
        if (!targetClass) return;
        
        const targetElement = document.querySelector(`.shopify-section.${targetClass}`);
        
        if (targetElement) {
          const isMobile = window.innerWidth <= 768;
          const yOffset = isMobile ? -104 : -132;
          const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
          
          window.scrollTo({
            top: y,
            behavior: "smooth"
          });
        }
      });
    });
    
    // Video control functions
    initializeVideoControls();
    
    function initializeVideoControls() {
      initMuteButtons();
      
      // Re-initialize when slides change
      document.addEventListener('full-screenSlideChanged', function(event) {
        setTimeout(function() {
          initMuteButtons();
        }, 200);
      });
    }
    
    function initMuteButtons() {
      const muteButtons = document.querySelectorAll('.mute-button');
      
      muteButtons.forEach(button => {
        // Remove old event listeners by cloning the button
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);
        
        newButton.addEventListener('click', function(e) {
          // Prevent click from triggering slider navigation
          e.stopPropagation();
          e.preventDefault();
          
          const slide = this.closest('.full-screen-slide');
          if (!slide) return;
          
          let video;
          // Button classes are switched in the HTML (mobile/desktop)
          if (this.classList.contains('mobile')) {
            video = slide.querySelector('video.full-screen-dekstop-visible');
          } else {
            video = slide.querySelector('video.full-screen-mobile-visible');
          }
          
          if (!video) return;
          
          const muteIcon = this.querySelector('.mute-icon');
          const unmuteIcon = this.querySelector('.unmute-icon');
          
          if (!muteIcon || !unmuteIcon) return;
          
          // Toggle mute state
          if (video.muted) {
            // Mute any previously unmuted video
            if (window.currentlyUnmutedVideo && window.currentlyUnmutedVideo !== video) {
              muteAllVideos();
            }
            
            // Unmute this video
            video.muted = false;
            window.currentlyUnmutedVideo = video;
            
            // Update button appearance
            muteIcon.style.display = 'none';
            unmuteIcon.style.display = 'block';
          } else {
            // Mute this video
            video.muted = true;
            if (window.currentlyUnmutedVideo === video) {
              window.currentlyUnmutedVideo = null;
            }
            
            // Update button appearance
            muteIcon.style.display = 'block';
            unmuteIcon.style.display = 'none';
          }
        });
      });
      
      updateMuteButtonStates();
    }
    
    function muteAllVideos() {
      if (!window.currentlyUnmutedVideo) return;
      
      window.currentlyUnmutedVideo.muted = true;
      window.currentlyUnmutedVideo = null;
      
      updateMuteButtonStates();
    }
    
    function updateMuteButtonStates() {
      const slides = document.querySelectorAll('.full-screen-slide');
      
      slides.forEach(slide => {
        const mobileVideo = slide.querySelector('video.full-screen-mobile-visible');
        const desktopVideo = slide.querySelector('video.full-screen-dekstop-visible');
        const mobileButton = slide.querySelector('.mute-button.mobile');
        const desktopButton = slide.querySelector('.mute-button.desktop');
        
        // Update desktop button (controls mobile video)
        if (mobileVideo && desktopButton) {
          updateButtonMuteState(desktopButton, mobileVideo.muted);
        }
        
        // Update mobile button (controls desktop video)
        if (desktopVideo && mobileButton) {
          updateButtonMuteState(mobileButton, desktopVideo.muted);
        }
      });
    }
    
    function updateButtonMuteState(button, isMuted) {
      if (!button) return;
      
      const muteIcon = button.querySelector('.mute-icon');
      const unmuteIcon = button.querySelector('.unmute-icon');
      
      if (!muteIcon || !unmuteIcon) return;
      
      if (isMuted) {
        muteIcon.style.display = 'block';
        unmuteIcon.style.display = 'none';
      } else {
        muteIcon.style.display = 'none';
        unmuteIcon.style.display = 'block';
      }
    }
    
    // Export key functions to window for external access
    window.fullScreenSlider = {
      goToSlide: function(index) {
        if (index >= 0 && index < state.slideCount) {
          goToSlide(index);
        }
      },
      nextSlide: nextSlide,
      prevSlide: prevSlide,
      updateSlider: updateSlider,
      preloadAdjacentSlides: preloadAdjacentSlides,
      initMuteButtons: initMuteButtons
    };
  });
})();